import { graphql } from "react-apollo";
import gql from "graphql-tag";
import React from "react";

import Loading from "../../loading";

class FetchInactiveUploads extends React.Component {
    render() {
        if (!this.props.data || this.props.data.loading) {
            return <Loading />;
        }

        return (
            <div>
                {React.cloneElement(this.props.children, {
                    uploads:
                        (this.props.data.userInactiveUploads &&
                            this.props.data.userInactiveUploads.uploads) ||
                        [],
                    loadMoreUploads: this.props.loadMoreUploads
                })}
            </div>
        );
    }
}

const query = gql`
    query($limit: Int, $uploadState: String, $offset: Int) {
        userInactiveUploads(
            limit: $limit
            uploadState: $uploadState
            offset: $offset
        ) {
            uploads {
                id
                svg
                dateDenied
                uploader {
                    username
                }
                state
            }
            totalCount
        }
    }
`;

export default graphql(query, {
    options: props => ({
        variables: {
            limit: props.limit,
            offset: props.offset,
            uploadState: props.uploadState
        }
    }),
    props({ data }) {
        return {
            data,
            loadMoreUploads() {
                const { totalCount, uploads } = data.userInactiveUploads;
                if (uploads.length >= totalCount) return Promise.resolve();

                return data.fetchMore({
                    variables: {
                        offset: data.userInactiveUploads.uploads.length
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        return {
                            userInactiveUploads: {
                                ...data.userInactiveUploads,
                                uploads: [
                                    ...previousResult.userInactiveUploads
                                        .uploads,
                                    ...fetchMoreResult.userInactiveUploads
                                        .uploads
                                ]
                            }
                        };
                    }
                });
            }
        };
    }
})(FetchInactiveUploads);
